import React, { useState, useEffect } from "react";
import { Button, Icon, Segment, Dimmer, Loader } from "semantic-ui-react";
import { Navigate, useNavigate } from "react-router-dom";
import "../css/Events.css";
import "../css/MyUniversity.css";
import "../css/MyRSOs.css";

export default function MyUniversity() {
    const[uniName, setUniName] = useState("");
    const[description, setDescription] = useState("");
    const[location, setLocation] = useState("");
    const[no_student, setNo_Student] = useState(0);
    const[domain, setDomain] = useState("");
    let navigate = useNavigate();

    useEffect(() => {
        console.log(localStorage.getItem('uniid'));
        handleGetUniversity();
    }, []);

    const redirectLogin = () => {
        localStorage.clear();
        navigate("/");
    };

    const redirectUniversity = () => {
        navigate("/MyUniversity");
    };

    const redirectRSO = () => {
        navigate("/RSO");
    };

    const redirectMyRSO = () => {
        if (localStorage.getItem("adminorsuper") == 0)
            navigate("/MyRSOs");
        else
            navigate("/ApproveRSOs");
    };

    const redirectMyEvent = () => {
        navigate("/ApproveEvents");
    };

    const redirectEvent = () => {
        navigate("/Events");
    };

    async function handleGetUniversity() {
        try {
            let info = {
                userid: localStorage.getItem("userid"),
                adminorsuper: localStorage.getItem("adminorsuper")
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/showUniversity.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "application/json" },
                }
            );

            let res = await response.json();
            console.log("This is the response error: " + res.error);

            if (res.error === "") {
                setUniName(res.name);
                setDescription(res.description);
                setLocation(res.location);
                setNo_Student(res.no_student);
                setDomain(res.domain);
            }
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div className="ui center aligned padded grid">
            <div className="row events-row" >
                <div className="events-blue-sidebar column three wide">
                    <h2 className="events-hi-user">Hi, {localStorage.getItem('first')}</h2>
                    <p className="events-subpage-link" onClick={redirectUniversity}>My University</p>
                    <p className="events-subpage-link" onClick={redirectMyRSO}>{(localStorage.getItem("adminorsuper") == 0) ? ("My RSOs") : ("Approve RSOs")}</p>
                    <p className="events-subpage-link" onClick={redirectMyEvent}>{(localStorage.getItem("adminorsuper") == 0) ? ("") : ("Approve Events")}</p>
                    <h2 className="events-sidebar-subtitle">EXPLORE</h2>
                    <p className="events-subpage-link" onClick={redirectRSO}>RSOs</p>
                    <p className="events-subpage-link" onClick={redirectEvent}>Events</p>
                    <Button icon onClick={redirectLogin}>
                        {(localStorage.getItem("adminorsuper") == 0) ? 
                            (<Icon className="event-icon" name='sign-out' size='large' />) :
                            (<Icon className="event-icon2" name='sign-out' size='large' />)}
                    </Button>
                </div>
                <div className="myuni-right-container column thirteen wide" >
                    <h2 className="ui horizontal divider header">{uniName}</h2>
                    {(uniName !== "") ?
                    (<Segment className="MyRSO-info-container"  >
                        <div class="ui raised segments">
                            <div class="ui raised primary teal segment">
                                <p>{description}</p>
                            </div>
                            <div class="ui raised  blue segment">
                                <p className="MyRSO-status">
                                    <b><u>Address:</u></b>
                                </p>
                                <p className="MyRSO-description">
                                    <b>{location}</b>
                                </p>
                            </div>
                            <div class="ui raised  teal segment">
                                <p className="MyRSO-status">
                                    <b><u>Population:</u></b>
                                </p>
                                <p className="MyRSO-description"><b>{no_student + " students"}</b></p>
                            </div>
                            <div class="ui raised  blue segment">
                                <p className="MyRSO-status">
                                    <b><u>Domain Name:</u></b>
                                </p>
                                <p className="MyRSO-description"><b>{domain}</b></p>
                            </div>
                        </div>
                    </Segment>) :
                    (<Dimmer active inverted>
                                    <Loader inverted content='Loading' />
                                </Dimmer>)}
                </div>
            </div>
        </div>
    );
}